<template>
  <div class="today-plan" :class="{'main-sheet-opened': open}">
    <v-bottom-sheet
        v-model="sheet"
        scrollable
        persistent
        no-click-animation
        hide-overlay
        fullscreen
        attach
        light
    >
      <v-card flat class="today-plan-sheet" color="transparent" :class="{'open': open, 'first':first}">
        <v-card-title>
          <v-btn text plain :ripple="false" class="btn-today-plan-opener" @click="sheetState">
            오늘의 미션
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          <v-btn v-if="isTravelMap"
                 block rounded depressed color="primary"
                 class="btn-today-plan-map btn-animation"
                 @click="travelMap">
            여행지도
          </v-btn>
        </v-card-subtitle>
        <v-card-text>
          <!-- <SolutionList /> -->
          <SolutionListNew />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!--    <v-overlay :value="open" />-->
  </div>
</template>
<script>
import store from '@/store'
import SolutionListNew from '@/components/layout/SolutionListNew'
import {mixinRemote} from "@/mixins";
export default {
  components:{
    SolutionListNew
  },
  mixins: [
    mixinRemote
  ],
  props: {
    isTravelMap: Boolean
  },
  data: () => ({
    sheet: false,
    open: false,
    first: true,
  }),
  async created (){
    if(this.solutionComplete){
      this.sheet = true;
      this.first = false
      this.sheetState()
    }else {
      setTimeout(() => {this.sheetOpen()},400);
    }
    await store.dispatch('getUseOrdDtl')
  },
  mounted (){
  },
  methods:{
    sheetOpen (){
      this.sheet = true;
      setTimeout(() => {this.first = false}, 800);
    },
    travelMap (){
      this.$router.push('/fo/travelMap');
    },
    sheetState (){
      this.open = !this.open;
      this.$emit('bottomSheetState',this.open);
    },
  }
};
</script>
